import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ShowContainer from "../ShowContainer";
import IconArrow from "../JSXIcons/IconArrow";
import "../chose_lang/chose-lang.scss";
import { setCurrency } from "../../../store/userSlice";
import { API_USER } from "../../../api/user";
import "./choose-currency.scss";
import { useAppSelector } from "../../../store/index.ts";
import useBalance from "../../../hooks/useBalance.js";
import ChooseCurrencyPlug from "./ChooseCurrencyPlug.jsx";

/**
 *
 * @param {Object} props
 * @param {boolean} props.onChange // локальный вариант использования компонента без запроса на сервер
 * @param {string} props.classNameUl
 * @param {string} props.myCurrency  // вывод конкретный валюты
 * @param {React.Component} props.FullReplenishRight  // компонент FullReplenishRight
 * @param {React.Component} props.FullControls  // компонент FullControls
 */
export default function ChooseCurrency({
  classNameUl = "",
  myCurrency,
  onChange,
  FullReplenishRight,
  FullControls
}) {
  const dispatch = useDispatch();
  const currencySite = useAppSelector((state) => state.user.currency);
  const currencies = useAppSelector((state) => state.common.currencies) || {};
  const isMobile = useAppSelector((state) => state.deviceSize.isMobile);
  const isAuth = useAppSelector((state) => state.user.isAuth);

  const [isOpen, setOpen] = useState(false);

  const currency = myCurrency || currencySite;
  const currenciesName = Object.keys(currencies);
  const openClass = isOpen ? "open" : "";

  useEffect(() => {
    if (!isAuth) return;
    if (!currency) return;

    API_USER.changeCurrency({ currency })
      .then((e) => {
        const data = e.data;
        dispatch(setCurrency(data.currency));
      })
      .catch(console.error);
  }, [currency]);

  const { getMainBalance, getBonusBalance } = useBalance();

  const bonusBalance = +getBonusBalance(currency);

  const onCurrencyContainerClick = () => {
    if (!isMobile) return;
    setOpen((prev) => !prev);
  };

  return (
    <ShowContainer condition={currenciesName?.length}>
      <div
        className={`choose-currency-container ${openClass}`}
        onMouseOver={() => (isMobile ? undefined : setOpen(true))}
        onMouseLeave={() => setOpen(false)}>
        <div className="choose-currency__wrapper">
          <span className="choose-currency__gradient" />
          <button className="choose-currency" onClick={onCurrencyContainerClick}>
            <span className="choose-currency__active">
              <span className="balance-value">
                <span className="main">{getMainBalance(currency).toLocaleString()}</span>
                <ShowContainer condition={!!bonusBalance}>
                  <span className="bonus">{bonusBalance.toLocaleString()}</span>
                </ShowContainer>
              </span>
              <span className="currency">{currency}</span>
              <IconArrow className="choose-currency__arrow" />
            </span>
          </button>
        </div>

        <div className="choose-currency__plug">
          <ul className={classNameUl}>
            {currenciesName.map((el, indx) => (
              <ChooseCurrencyPlug
                key={indx}
                currency={currency}
                currencyKey={el}
                onChange={onChange}
                setOpen={setOpen}
              />
            ))}

            <ShowContainer condition={FullControls}>{<FullControls />}</ShowContainer>
          </ul>
        </div>

        <ShowContainer condition={FullReplenishRight}>
          <FullReplenishRight />
        </ShowContainer>
      </div>
    </ShowContainer>
  );
}
